import { i18n } from '@/plugins/i18n'

export const dedicatedStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
    HAS: 5,
    DOES_NOT_HAVE: 6,
    SEND_TO_PSP: 9,
    REJECTED_BY_PSP: 10,
}

export const dedicatedCollectiveType = {
    DIRECET_TO_PSP: 0,
    USE_PAYMENT_HELPER:1
}

export const dedicatedStatusStr = {
    ACTIVE: i18n.t('dedicated_status.active'),
    PENDING: i18n.t('dedicated_status.pending'),
    REJECTED: i18n.t('dedicated_status.rejected'),
    BLOCKED: i18n.t('dedicated_status.blocked'),
    HAS: i18n.t('dedicated_status.has'),
    REJECTED_BY_PSP: i18n.t('dedicated_status.rejected_by_psp'),
    DOES_NOT_HAVE: i18n.t('dedicated_status.does_not_have'),
    SEND_TO_PSP: i18n.t('dedicated_status.send_to_psp'),
    get(status) {
        let status_str = null;
        Object.keys(dedicatedStatus).forEach(function (item) {
            if(dedicatedStatus[item] === status) {
                status_str = dedicatedStatusStr[item]
            }
        })

        return status_str
    }
}

export const dedicatedCollectiveTypeStr = {
    DIRECET_TO_PSP: i18n.t('dedicated_collective_type.direct_to_psp'),
    USE_PAYMENT_HELPER: i18n.t('dedicated_collective_type.use_payment_helper'),
}

export const dedicatedVariant = (status) => {
    if(status === dedicatedStatus.ACTIVE || status === dedicatedStatus.HAS) {
        return 'success'
    }

    if(status === dedicatedStatus.DOES_NOT_HAVE
        || status === dedicatedStatus.REJECTED
        || status === dedicatedStatus.BLOCKED
        || status === dedicatedStatus.REJECTED_BY_PSP
    ) {
        return 'danger'
    }

    if(status === dedicatedStatus.PENDING
        || status === dedicatedStatus.SEND_TO_PSP
    ) {
        return 'warning'
    }

    return 'info'
} 